import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/** Colores propios de tokens.css: sin esto, tailwind-merge confunde `text-ceniza` con un tamaño. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'carbon',
        'hierro',
        'forja',
        'escoria',
        'escoria-2',
        'ceniza',
        'ceniza-2',
        'hueso',
        'brasa',
        'brasa-honda',
        'brasa-tenue',
        'ok',
        'warn',
        'danger',
        'info',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
